import * as types from '../actionType'

const initialState = []

const cartDetail = (state = initialState, action) => {
    switch (action.type) {
        case types.CART_DETAILS:
            return action.payload
        default:
            return state
    }
}

export { cartDetail };
